var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_vm._v(_vm._s(_vm.value)),(_vm.showAction)?_c('span',{staticClass:"pl-2",on:{"click":function($event){return _vm.action(_vm.item)}}},[_c('e-hint-tooltip',{attrs:{"top":"","icon":_vm.icon}},[_vm._v(_vm._s(_vm.$t(_vm.tooltipText)))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }